class PaleoRewards extends HTMLElement {
  constructor() {
    super();
    this.setAttribute('pageMax', '6');
    emphasizeMenuLink();

  }

  render() {
    // this.id = getCustomerId();
    this.loadRewards();

  if (this.getAttribute('details')) {
    this.updatePoints()
  }
    if (this.getAttribute('coupons')) {
      this.updateCoupons()
    }}

    updatePoints() {
      const pointsBalance = JSON.parse(this.getAttribute('details')).points;
      if (pointsBalance) {
        this.querySelector('slot[name="balance"]').innerHTML  = pointsBalance;
      }

    }

    updateCoupons() {
      if (!this.coupons) return;
      let couponData = JSON.parse(this.coupons);
      let couponCount = 0;
      Object.keys(couponData).forEach(key => {
        let coupon = document.createElement('rewards-coupon');
        Object.keys(couponData[key]).map(item => {
          coupon.setAttribute(item, couponData[key][item]);
          if (couponCount > parseInt(this.pageMax)) coupon.style.display = 'none';
        });
        this.querySelector('slot[name="coupons"]').appendChild(coupon);
      })
    }



    get rewardsId() {
        return this.getAttribute('rewardsId' || undefined);
      }

    set rewardsId(val) {
      return this.setAttribute('rewardsId', val);
    }

    get providerId() {
      return this.getAttribute('providerId' || undefined);
    }

    set providerId(val) {
      return this.setAttribute('providerId', val);
    }

    get customerId() {
      return this.getAttribute(' customerId') || undefined;
    }

    set customerId(val) {
      return this.setAttribute('customerId', val);
    }

    get details() {
      return this.getAttribute('details') || undefined;
    }

    set details(val) {
      return this.setAttribute('details', val);
    }

    get coupons() {
      return this.getAttribute('coupons') || undefined;
    }

    set coupons(val) {
      return this.setAttribute('coupons', val);
    }

    get earnList() {
      return this.getAttribute('earnList') || undefined;
    }

    set earnList(val) {
      return this.setAttribute('earnList', val);
    }

  get pageMax() {
    return this.getAttribute('pageMax') || undefined;
  }

  set pageMax(val) {
    return this.setAttribute('pageMax', val);
  }

  static get observedAttributes() {
    return ['rewardsId', 'providerId', 'customerId', 'details', 'coupons', 'earnList', 'pageMax'];
  }

  connectedCallback() {
    const template = document.getElementById('rewards-template');
    const node = document.importNode(template.content, true);
    this.appendChild(node);
    this.render();
  }

  disconnectedCallback() {

  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    this.render();
    if (newValue !== oldValue) {
      this[attrName] = this.hasAttribute(attrName);
      // this.render();
    }
  }

  loadRewards() {
    if (!this.hasAttribute('details')) {
      const cId = '7227900592222';
      let rewardsUrl = `https://app.marsello.com/Portal/Widget/GetContent?aid=${this.rewardsId}&aprovid=${this.providerId}&cSourceProvId=${cId}&st=`;
      fetch(rewardsUrl)
        .then((response) => response.text())
        .then((text) => {
          let rewardsData = JSON.parse(text);

          let customerDetails = {
            marselloCustomerId: rewardsData['CustomerDetail']['Id'],
            marselloToken: rewardsData['CustomerDetail']['Token'],
            points: rewardsData['CustomerDetail']['AvailablePoints']
          };
          let customerCoupons = {}
          rewardsData['Coupons'].forEach(item => {
            customerCoupons[`${item.Id}`] = {
              code: item['Code'],
              description: item['Description'],
              expiresAt: item['ExpiresAt'],
              terms: item['Terms'],
              title: item['Title'],
              type: item['Type'],
              couponType: item['CouponType'],
              alert: item['Alert']
            }
          })

          let customerEarnList = rewardsData['EarnList'].map(item => ({
            title: item['Title'],
            description: item['Description'],
            action: item['Description']['Action'] ? (item['Description']['Action']['Url'] ? item['Description']['Action']['Url'] : null) : null
          }))

          this.setAttribute('details', JSON.stringify(customerDetails));
          this.setAttribute('coupons', JSON.stringify(customerCoupons));
          this.setAttribute('earnList', JSON.stringify(customerEarnList));


        })
      return null;
    }
  }




}
customElements.define('paleo-rewards', PaleoRewards);

class RewardsIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
    if (!this.icon) return;
    this.icon.classList.add('animate__animated', 'animate__pulse','animate__slow', 'animate__infinite');
  }

  connectedCallback() {

  }
}

customElements.define('rewards-icon', RewardsIcon);

